import { FunctionalComponent, h } from "@stencil/core";
import clsx from "clsx";

interface TextareaInputProps {
  key: string | number;
  name: string;
  label: string;
  hint?: string;
  error?: string;
  onInput: (event: InputEvent) => void;
  getClass: (path: string) => string;
}

export const TextareaInput: FunctionalComponent<TextareaInputProps> = (props) => {
  const { name, label, hint, error, key, onInput, getClass } = props;

  return (
    <div class={clsx("hr-field", getClass('field'))} key={key}>
      <label class={clsx("hr-label", getClass('label'))}>
        <div class={clsx("hr-label-text", getClass('labelText'))}>
          {label}
        </div>
      </label>
      <textarea
        name={name}
        class={clsx("hr-input hr-input-textarea", getClass('input'), getClass('inputTextarea'))}
        onInput={onInput}
      />
      {hint && (
        <div class={clsx("hr-input-hint", getClass('inputHint'))}>
          {hint}
        </div>
      )}
      {error && (
        <div class={clsx("hr-input-error", getClass('inputError'))}>
          {error}
        </div>
      )}
    </div>
  )
}
